import * as React from 'react';

export interface MobileLine {
  /**
   * The media query that counts as mobile; `(max-width: 767px)` unless an app
   * sets its own.
   */
  query: string;

  /**
   * `drawer`: a ResponsiveDialog renders the kit's Drawer on mobile (the phone
   * sheet); `sheet` renders the kit's bottom Sheet.
   */
  sheet: 'drawer' | 'sheet';
}

export const DEFAULT_MOBILE_LINE: MobileLine = { query: '(max-width: 767px)', sheet: 'sheet' };

/**
 * Read through `useMobileLine` and set through `MobileLineProvider`.
 */
export const MobileLineContext = React.createContext<MobileLine>(DEFAULT_MOBILE_LINE);

/**
 * The nearest provider's line, or the kit's default without one.
 */
export function useMobileLine(): MobileLine {
  return React.useContext(MobileLineContext);
}
